/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Spacer, ExpandCollapse, Typography } from '@telus-uds/components-web';
import { Box } from '../design/css';
import 'react-datepicker/dist/react-datepicker.css';
import './styles.css';
import {
  PROVINCE_MULTISELECT_OPTIONS,
  renderDashboardMultiSelectRows,
  renderDashboardDualDateRangeFilters
} from './components';

const OCDRFilters = ({
  data,
  updateFilters,
  onApplyFilters,
  onResetFilters,
  filterState,
  staticLabels,
  isMyOrder
}) => {
  const {
    startDate,
    endDate,
    completedStartDate,
    completedEndDate,
    channelId,
    province,
    productId,
    status,
    submitter,
    dealership,
    salesRepName
  } = filterState;
  const {
    filterByChannel,
    filterByProvince,
    filterByProducts,
    filterByStatus,
    filterBySubmitter,
    filterByOpenedDates,
    filterByValidationDates,
    startDateLabel,
    endDateLabel,
    buttonApply,
    buttonReset,
    filtersDropdownTitle,
    filterByDealership
  } = staticLabels;
  const {
    channels,
    products,
    statuses,
    submitters,
    dealerships,
    salesRepNames
  } = data;
  const channelList =
    channels &&
    channels.map(channel => ({ label: channel.text, value: channel.value }));
  const productList =
    productId &&
    products.map(product => ({ label: product.text, value: product.value }));
  const statusList =
    statuses &&
    statuses.map(statusdata => ({
      label: statusdata.text,
      value: statusdata.value
    }));
  const dealershipsList =
    dealerships &&
    dealerships.map(dealership => ({
      label: dealership.name,
      value: dealership.id
    }));
  const salesRepNameList =
    salesRepNames &&
    salesRepNames.map(salesRepNames => ({
      label: `${salesRepNames.firstName} ${salesRepNames.lastName}`,
      value: salesRepNames.id
    }));

  let multiSelectFilters = [
    {
      label: filterByProducts,
      name: 'productId',
      options: productList,
      value: productId
    },
    {
      label: filterByStatus,
      name: 'status',
      options: statusList,
      value: status
    },
    {
      label: 'Filter By Sales Rep Name:',
      name: 'salesRepName',
      options: salesRepNameList,
      value: salesRepName
    },
    {
      label: filterByProvince,
      name: 'province',
      options: PROVINCE_MULTISELECT_OPTIONS,
      value: province
    },
    {
      label: filterByChannel,
      name: 'channelId',
      options: channelList,
      value: channelId
    },
    {
      label: filterByDealership,
      name: 'dealership',
      options: dealershipsList,
      value: dealership
    }
    // {
    //   label: filterBySubmitter,
    //   name: 'submitter',
    //   options: (submitters || []).map(op => ({
    //     value: op.id,
    //     label: `${op.firstName} ${op.lastName}`
    //   })),
    //   value: submitter
    // }
  ];

  if (isMyOrder)
    multiSelectFilters = multiSelectFilters.filter(
      filter => filter.name !== 'submitter' && filter.name !== 'channelId'
    );

  return (
    <ExpandCollapse initialOpen={[]}>
      {(expandProps) => (
        <ExpandCollapse.Panel
          {...expandProps}
          panelId="filters"
          control={<Typography variant={{ bold: true }}>{filtersDropdownTitle}</Typography>}
        >
          <div className="row">
            {renderDashboardMultiSelectRows(multiSelectFilters, updateFilters)}
            {renderDashboardDualDateRangeFilters({
              updateFilters,
              filterByOpenedDates,
              filterByValidationDates,
              startDateLabel,
              endDateLabel,
              startDate,
              endDate,
              completedStartDate,
              completedEndDate
            })}
          </div>

          <Spacer space={3} />
          <Box display="flex" justifyContent="center" flexDirection="row">
            <Button onClick={onApplyFilters} variant={{ priority: 'low' }}>
              {buttonApply}
            </Button>
            <Box width="2"> </Box>
            <Button onClick={onResetFilters}>{buttonReset}</Button>
          </Box>
        </ExpandCollapse.Panel>
      )}
    </ExpandCollapse>
  );
};

export default OCDRFilters;

OCDRFilters.propTypes = {
  staticLabels: PropTypes.object.isRequired,
  onApplyFilters: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  filterState: PropTypes.shape({
    filterStatus: PropTypes.string,
    startDate: PropTypes.dateFormat,
    endDate: PropTypes.dateFormat,
    completedStartDate: PropTypes.dateFormat,
    completedEndDate: PropTypes.dateFormat,
    submitter: PropTypes.array,
    status: PropTypes.array,
    channelId: PropTypes.array,
    province: PropTypes.array,
    productId: PropTypes.array
  }).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired
};
